import Service from "./Service";

export default class LoqateService extends Service {
    constructor() {
        super();
    }

    postcodeValidation(postcode) {
        return this.axios.post('/validate-postcode', {postcode});
    }

    validatePostcode(postcode) {
        return this.axios.post('/postcode', {postcode});
    }

    getAvailableAddresses(postcode) {
        this.getLocationId(postcode)
            .then(res => {
                let container = res.data.Items[0]['Id'];
                return this.axios.post('/addresses', {postcode, container});
            });
    }

    getAvailableAddressesNew(postcode, container, type) {
        return this.axios.post('/addresses', {postcode, container, type});
    }

    validatePhoneNumber(phone) {
        return this.axios.post('/phone-verification', {phone});
    }

    getLocationId(postcode) {
        return this.axios.post('/location', {postcode});
    }
}
